<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex class="mb-2" xs12 sm12 md4 v-for="(item, i) in items" :key="i">
        <router-link :to="item.route">
          <div class="pa-4 text-center">
            <v-icon class="mb-3 d-block">{{ item.icon }}</v-icon>
            <span class="m-0">{{ item.title }}</span>
          </div>
        </router-link>
      </v-flex>

      <v-flex v-show="$isLoading('created')" xs12 sm12 md12>
        <v-progress-linear :height="2" :indeterminate="true"></v-progress-linear>
      </v-flex>

      <!-- <v-flex class="text-left" xs12 sm12 md12 v-for="(project, index) in start.projectsMissingPlanning" :key="'project-' + index">
        <div class="v-alert v-alert--outline warning--text">
          <i aria-hidden="true" class="v-icon material-icons theme--light v-alert__icon">priority_high</i>
          <div>
            <span v-html="$language('pages.start.projectNotification', wrapKeyword(project.Name), project.DepartmentNumbers.map(wrapKeyword))"></span>
          </div>
        </div>
      </v-flex> -->

      <v-flex class="text-left" xs12 sm12 md12 v-for="(department, index) in start.departmentsMissingEmployees" :key="'department-' + index">
        <div class="v-alert v-alert--outline warning--text">
          <i aria-hidden="true" class="v-icon material-icons theme--light v-alert__icon">priority_high</i>
          <div>
            <span v-html="$language('pages.start.departmentNotification', wrapKeyword(department))"></span>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import loading from '@/mixin/loading';
import start from './start';

export default {
  name: 'start',
  mixins: [loading, start],
  data() {
    return {
      items: [
        { route: 'employees', title: this.$language('pages.start.employees'), icon: 'assignment_ind' },
        { route: 'projects', title: this.$language('pages.start.projects'), icon: 'assignment' },
        { route: 'planning', title: this.$language('pages.start.planning'), icon: 'assessment' },
      ],
    };
  },
  methods: {
    wrapKeyword(keyword) {
      return `<span class="notification-keyword">${keyword}</span>`;
    },
  },
  async created() {
    document.title = this.$language('pages.start.title');
    this.$store.commit('page/title', this.$language('pages.start.menuTitle'));
    this.$startLoading('created');
    try {
      await Promise.all([
        this.fetchDepartmentsMissingEmployees(),
        // this.fetchProjectsMissingPlanning(),
      ]);
    } catch (err) {
      console.log(err);
      this.$store.commit('snackbar/show', (err.response && err.response.data && err.response.data.message) || err.message);
      throw err;
    }
    this.$stopLoading('created');
  },
};
</script>

<style lang="scss" scoped>
  a {
    color: #333 !important;
    text-decoration: none;
    div {
      width: 100%;
      border: 1px solid black;
      background-color: #E0F2FC;
      cursor: pointer;
      .v-icon {
        color: black !important;
        font-size: 50px;
      }
      span {
        font-size: 16px;
      }
    }
  }
  .v-alert {
    display: flex !important;
    align-items: center !important;
    padding: 15px;
    background-color: lightgoldenrodyellow;
    border: 1px solid #efb52c;
    i {
      color: #efb52c !important;
    }
  }

  /deep/ .notification-keyword {
    font-weight: bold;
    color: #efb52c;
  }
</style>
